import { render, staticRenderFns } from "./systemSetting.vue?vue&type=template&id=586dcc88&scoped=true"
import script from "./systemSetting.vue?vue&type=script&lang=js"
export * from "./systemSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586dcc88",
  null
  
)

export default component.exports